// See: https://medium.com/hackernoon/unlocking-web-audio-the-smarter-way-8858218c0e09

import { useEffect, useRef } from 'react';

let context: AudioContext;

export function useWebAudioTouchUnlock() {
  const audioContextRef = useRef(context);
  useEffect(() => {
    if (!audioContextRef.current) {
      context = audioContextRef.current = new AudioContext();
    }

    const needsUnlock =
      context.state === 'suspended' && 'ontouchstart' in window;

    if (!needsUnlock) return;

    async function unlock() {
      try {
        await context.resume();
      } catch (e) {
        console.warn('AudioContext could not be unlocked:', e);
      }

      document.body.removeEventListener('touchstart', unlock);
      document.body.removeEventListener('touchend', unlock);

      // console.log('AudioContext was unlocked');
    }

    document.body.addEventListener('touchstart', unlock, false);
    document.body.addEventListener('touchend', unlock, false);

    return () => {
      document.body.removeEventListener('touchstart', unlock);
      document.body.removeEventListener('touchend', unlock);
    };
  });
}